export function HowItWorksPage() {
  return (
    <section className="page" id="how-it-works" data-testid="dp-page-how-it-works">
      <div className="wrap flow" style={{ paddingTop: 96, paddingBottom: 96 }}>
        <div>
          <div className="eyebrow">How Zephix works</div>
          <h2 style={{ fontSize: "clamp(35px,4vw,52px)", margin: "12px 0 8px" }}>
            A governed workflow, ready to validate.
          </h2>
          <div className="steps">
            <div className="step">
              <h3>Start from a practical template</h3>
              <p>
                Launch work using a defined project structure instead of configuring a blank system
                from scratch.
              </p>
            </div>
            <div className="step">
              <h3>Assign ownership and capture risk</h3>
              <p>
                Give one accountable project manager a clear view of risks, mitigation actions, and
                dependencies.
              </p>
            </div>
            <div className="step">
              <h3>Use approval checkpoints</h3>
              <p>
                Bring evidence and approval into the work where important delivery decisions are made.
              </p>
            </div>
            <div className="step">
              <h3>Give leaders decision visibility</h3>
              <p>Surface project health, risks, and the next decision that requires attention.</p>
            </div>
          </div>
        </div>
        <aside className="mini">
          <div className="miniHead">
            <b>Workflow checkpoint</b>
            <span className="pill">Concept preview</span>
          </div>
          <div className="check">
            <span>Required evidence</span>
            <span>Review</span>
          </div>
          <div className="check">
            <span>Project risk review</span>
            <span>Review</span>
          </div>
          <div className="check">
            <span>Approval checkpoint</span>
            <span>Decision</span>
          </div>
          <div className="check">
            <span>Leadership decision view</span>
            <span>Visible</span>
          </div>
          <div className="fakeAction">Guided approval flow →</div>
          <p className="small" style={{ margin: "15px 0 0" }}>
            The exact pilot workflow will be validated with design partners before broader release.
          </p>
        </aside>
      </div>
    </section>
  );
}
